import { useBrokerDetailsStore, FormField } from '../../../state/brokerDetailsStore';
import { useBrokerFieldFieldChanged } from '../../../hooks/useBrokerFieldChanged';
import { StateDropDown } from '@apply/components';
import { ShowIf } from '@apply/ui';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const StateField = () => {
    const value = useBrokerDetailsStore((s) => s.homeAddress.state);
    const updateHomeAddress = useBrokerDetailsStore((s) => s.updateHomeAddress);
    const isBroker = useBrokerDetailsStore((s) => s.isBroker);
    const changed = useBrokerFieldFieldChanged(FormField.HomeAddressState);
    return (
        <>
            <StateDropDown
                id='hState'
                value={value}
                onChange={(v) => updateHomeAddress({ state: v })}
                label='State'
                width={'auto'}
                required={isBroker}
            />
            <ShowIf showIf={changed}>
                <FontAwesomeIcon
                    icon={'asterisk'}
                    className='required-icon'
                />
            </ShowIf>
        </>
    );
};
